import React, { memo, useCallback, useEffect, useMemo, useState } from "react";

import { useDispatch } from "react-redux";

import { useReduxSelector } from "@hooks/useReduxSelector";
import {
  employeStatisticsActions,
  salaryStatisticsActions,
  salaryEvolutionActions,
} from "@store/actions";

import "@css/pages/employer/listeEmployer.css";

import { mapEmplacementToDevise } from "@helpers/_functions";

import EmployeTabFilter from "../../components/EmployeTabFilter";
// import Accordion from "@components/accordionMobiles/AccordionMobile";
// import ButtonApply from "@components/buttons/ButtonApply";
// import { StatisticContext } from "../../utils/employe-context";
import Graphs from "./Graphs";
import { INIT_EVOLUTION } from "@helpers/_constants";

const Statistique = ({ avalaibleSections}) => {
  const [applyClicked, setApplyClicked] = useState(false);
  const dispatch = useDispatch();
  const salaryStatistics = useReduxSelector(
    ({ enterpriseEmployeData }) => enterpriseEmployeData.salaryStatistics,
  );
  const salaryEvolutions = useReduxSelector(
    ({ enterpriseEmployeData }) => enterpriseEmployeData.salaryEvolutions,
  );
  const emplacements = useReduxSelector(
    ({ commonData }) => commonData.emplacements,
  );

  const deviseList = useMemo(
    () => mapEmplacementToDevise(emplacements),
    [emplacements],
  );
  const employeStatistics = useReduxSelector(
    ({ enterpriseEmployeData }) => enterpriseEmployeData.employeStatistics,
  );

  const [selectedDevise, setSelectedDevise] = useState("");
  const [selectedDeviseEvolution, setSelectedDeviseEvolution] = useState("");
  const [selectedYearEvolution, setSelectedYearEvolution] = useState("");
  const [selectedYearsEvolution, setSelectedYearsEvolution] = useState([...INIT_EVOLUTION]);
  useEffect(() => {
    return () => {
      dispatch({
        type: "enterpriseEmployeData/SET_SALARY_EVOLUTION",
        payload: {
          list: [],
          filter: {},
          devise: "",
          isLoaded: true,
          isFiltered: false
        }
      });
    };
  }, []);
  useEffect(() => {
    if (!employeStatistics?.isLoaded || employeStatistics?.isFiltered)
      dispatch(employeStatisticsActions.loadData);

    let devise = "";
    if (Array.isArray(emplacements)) {
      devise = emplacements?.[0]?.currency?.slice(-4, -1);
    }
    if (!salaryStatistics?.isLoaded || salaryStatistics?.isFiltered) {
      dispatch(
        salaryStatisticsActions.loadData({
          devise,
        }),
      );
    }
    if (!salaryEvolutions?.isLoaded || salaryEvolutions?.isFiltered) {
      dispatch(
        salaryEvolutionActions.loadData({
          devise,
        }),
      );
    }
  }, []);

  useEffect(() => {
    if (employeStatistics?.isLoaded && employeStatistics.isDataOutdated) {
      dispatch(employeStatisticsActions.refreshData);
    }

    if (salaryStatistics?.isLoaded && salaryStatistics.isDataOutdated) {
      dispatch(salaryStatisticsActions.refreshData);
    }
  }, [
    dispatch,
    employeStatistics?.isDataOutdated,
    employeStatistics?.isLoaded,
    salaryStatistics?.isDataOutdated,
    salaryStatistics?.isLoaded
  ]);

  const onFilterClicked = useCallback(
    (filterData = {}) => {
      const { employes, emplacements, groupes, postes } = filterData;
      const filters = {
        postes,
        emplacements,
        groups: groupes,
        employers: employes,
      };

      dispatch(employeStatisticsActions.filterData({ filter: filters }));
      dispatch(
        salaryStatisticsActions.filterData({
          devise: selectedDevise,
          filter: filters,
        }),
      );
      dispatch(
        salaryEvolutionActions.filterData({
          devise: selectedDeviseEvolution || deviseList[0]._id,
          year: selectedYearEvolution,
          filter: filters,
          years: selectedYearsEvolution
        }),
      );
      setApplyClicked(true);
      setTimeout(() => setApplyClicked(false));
    },
    [selectedDevise, selectedYearEvolution, selectedDeviseEvolution, selectedYearsEvolution],
  );

  return (
    <div className="arh-rounded arh-flex arh-flex-col arh-space-y-2">
      {/* Head Desktop */}
      <div className="arh-bg-white">
        <EmployeTabFilter
          onFilter={onFilterClicked}
          withPostes
          isLoading={Boolean(employeStatistics?.isLoading)}
          additionalClassParent="arh-m-4 arh-mx-8"
        />
      </div>

      {/* Container desktop */}
      <Graphs
        setSelectedDevise={setSelectedDevise}
        setSelectedDeviseEvolution={setSelectedDeviseEvolution}
        setSelectedYearEvolution={setSelectedYearEvolution}
        setSelectedYearsEvolution={setSelectedYearsEvolution}
        applyClicked={applyClicked}
        deviseList={deviseList}
        avalaibleSections={avalaibleSections}
      />
      {/* End Container Desktop */}
    </div>
  );
};

export default memo(Statistique);
